import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerFormChangedEvent extends AbstractEvent {
  constructor(
    public player: Player,
    public newBaseForm: number,
    public newForm: number,
    public nextFormChangeAt: Date,
  ) {
    super();
  }
}